module.exports = __webpack_public_path__ + "img/not-convex.4d613aee.svg";